export default __webpack_public_path__ + "static/media/metoza.1aa963b5.svg";